var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "navigation-tabs"
  }, [_c('router-link', {
    staticClass: "navigation-tab",
    attrs: {
      "to": {
        name: 'projects'
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('my.projects')) + " ")]), _c('router-link', {
    staticClass: "navigation-tab",
    attrs: {
      "to": {
        name: 'partners'
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('my.partners')) + " ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }